import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { BuildJsonType, EnhancedAppointment } from '@bb/domain/dist/types';

const getExternalAppointment = async (
  dashboardId: string,
  appointmentId: string,
) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/list/${appointmentId}`,
    method: 'get',
  };

  const { data } =
    await axios.request<BuildJsonType<EnhancedAppointment>>(config);

  return data;
};

export default getExternalAppointment;
